export default __webpack_public_path__ + "static/media/Slide3.3c5eccbe.jpg";